const getters = {
  works: state => state.works,
  work: state => state.work,
}

export default getters;
